module.exports = __webpack_public_path__ + "static/media/megha_content.4b259b3a.jpg";